import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';
import Utils from '../../../../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Badge from '@material-ui/core/Badge';
import styles from './styles/competencyselectfield.scss';

// eslint-disable-next-line css-modules/no-unused-class
import competencyIcons from '../../../../../style/competencyicons/competencyicons.scss';

class CustomCompetencyBadge extends React.Component {
    render() {
        const { children } = this.props;

        return (
            <Badge
                badgeContent="c"
                overlap="rectangular"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                classes={{
                    badge: styles.customCompetencyBadge
                }}
            >
                {children}
            </Badge>
        );
    }
}

export default class CompetencySelectField extends React.Component {
    render() {
        const {
            id,
            title,
            options,
            emptyValue,
            error,
            errorText,
            helperText,
            required,
            disabled,
            multiple,
            inputValue,
            onBlur,
            onFocus,
            valueOptions,
            uiSchema,
            showModalToAddCustomCompetency,
            i18n
        } = this.props;

        const { classes = {} } = uiSchema;
        const onChange = ({ target: { value } }) => {

            if (!multiple) {
                return this.props.onChange(id, value === '' ? emptyValue : value);
            }

            // if no values were selected, return the first value as an array
            if (!Utils.isArray(inputValue)) {
                return this.props.onChange(id, [value]);
            }

            const selectedValues = [...inputValue];

            if (~selectedValues.indexOf(value)) {
                selectedValues.splice(selectedValues.indexOf(value), 1);
            } else {
                selectedValues.push(value);
            }

            return this.props.onChange(id, selectedValues);
        };

        const grouped = !!(options.groups && options.groups.length);
        const chips = grouped ? {} : [];

        valueOptions.forEach((valueOption, i) => {
            const { key, label, group, icon, definitionText, isGlobalCompetency } = valueOption;
            let checked = false;
            const optionDisabled = disabled ? disabled : valueOption.disabled;

            if (inputValue) {
                if ((multiple && Utils.isArray(inputValue) && ~inputValue.indexOf(key)) ||
                    inputValue === key) {
                    checked = true;
                }
            }

            let chipContainerClass = styles.chipContainer;
            let chipLabelClass = styles.chipLabel;

            if (classes.chipContainer) {
                chipContainerClass += ` ${classes.chipContainer}`;
            }

            const chipLabelClasses = [
                classes.labelContainer,
                classes.chipLabelSelected,
                classes.chipLabelDisabled
            ];

            chipLabelClasses.forEach(styleClass => {
                if (styleClass) {
                    chipLabelClass += ` ${styleClass}`;
                }
            });

            if (checked) {
                chipLabelClass += ` ${styles.chipLabelSelected}`;
            }

            if (optionDisabled) {
                chipLabelClass += ` ${styles.chipLabelDisabled}`;
            }

            let chipArray = chips;

            // determine which group to add this option to
            if (grouped) {
                if (!group) {
                    return;
                }

                if (!chips[group]) {
                    chips[group] = [];
                }
                chipArray = chips[group];
            }

            chipArray.push(
                <div key={ `checkable-option-${id}-${i}` } className={ chipContainerClass }>
                    <label
                        htmlFor={ `${id}-${i}` }
                        className={ chipLabelClass }
                        onBlur={ onBlur && (() => onBlur({ id, value: key })) }
                        onFocus={ onFocus && (() => onFocus({ id, value: key })) }
                    >
                        {!isGlobalCompetency
                            ? <CustomCompetencyBadge>
                                <figure className={styles.figure}><i className={ `${competencyIcons.icon} ${competencyIcons[icon]}` } /></figure>
                            </CustomCompetencyBadge>
                            : <figure className={styles.figure}><i className={ `${competencyIcons.icon} ${competencyIcons[icon]}` } /></figure>}
                        <input
                            className={ `${styles.input} ${classes.input || ''}` }
                            type={ multiple ? 'checkbox' : 'radio' }
                            id={ `${id}-${i}` }
                            name={ id }
                            value={ key }
                            checked={ checked }
                            onChange={ onChange }
                            disabled={ optionDisabled }
                        />
                        <div className={ styles.labelContent }>
                            <span className={ classes.label || '' }>{ label }</span>
                            <div>
                                <section className={styles.tooltip}>
                                    <div className={styles.info_btn}><FontAwesomeIcon icon={'info-circle'}/>
                                        <span>{definitionText}</span>
                                    </div>
                                </section>
                                {!isGlobalCompetency && options.canAddCustomCompetencies ? <button
                                    className={styles.editButton}
                                    onClick={event => showModalToAddCustomCompetency(event, valueOption)}
                                >
                                    <FontAwesomeIcon icon={'pencil'}/>
                                    <span>{i18n.cp_company_settings_edit}</span>
                                </button> : null}
                            </div>
                        </div>
                    </label>
                </div>
            );
        });

        let renderChips = [];

        if (grouped) {
            let labelContainerClass = styles.groupLabelContainer;
            let groupChipContainerClass = '';

            if (options.groupLabelPlacement === 'top') {
                labelContainerClass += ` ${styles.groupLabelTop}`;
            } else if (options.groupLabelPlacement === 'left') {
                labelContainerClass += ` ${styles.groupLabelLeft}`;
                groupChipContainerClass = styles.groupInlineChipContainer;
            }

            if (classes.groupLabelContainer) {
                labelContainerClass += ` ${classes.groupLabelContainer}`;
            }

            if (classes.groupChipContainer) {
                groupChipContainerClass = groupChipContainerClass
                    ? `${groupChipContainerClass} ${classes.groupChipContainer}` : classes.groupChipContainer;
            }

            options.groups.forEach(group => {
                let groupLabel = '';

                for (let i = 0; i < options.groups.length; i++) {
                    if (options.groups[i].key === group.key) {
                        groupLabel = options.groups[i].label;
                        break;
                    }
                }

                const isCustomCompetencyGroup = group.key === 'custom_competencies';
                const showAddButton = isCustomCompetencyGroup && options.canAddCustomCompetencies;

                renderChips.push(
                    <div key={ `${id}-${group.key}` } className={ styles.chipGroup }>
                        <div className={ `${labelContainerClass} ${showAddButton ? styles.customCompetencyLabel : ''}` }>
                            <span>{ groupLabel }</span>
                            {showAddButton ? <button
                                type="button"
                                onClick={event => showModalToAddCustomCompetency(event)}
                                className={styles.addCustomCompetencyButton}
                            >
                                <FontAwesomeIcon icon={'plus'}/>
                                {i18n.cp_company_settings_add}
                            </button> : null}
                        </div>
                        {showAddButton && !chips[group.key]
                            ? <div className={styles.noCustomCompetencies}>
                                <CustomCompetencyBadge>
                                    <figure className={styles.figure} />
                                </CustomCompetencyBadge>
                                <p><strong>{i18n.cp_company_settings_competencies_custom_competencies_no_items_title}</strong></p>
                                <span>{i18n.cp_company_settings_competencies_custom_competencies_no_items_body}</span>
                            </div>
                            : <div className={groupChipContainerClass}>
                                {chips[group.key]}
                            </div>
                        }
                    </div>
                );
            });
        } else {
            renderChips = chips;
        }

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    classes={{
                        root: `${classes.fieldSet || ''}`
                    }}
                >
                    { title ? <FormLabel
                        component="legend"
                        classes={{
                            root: classes.titleContainer || ''
                        }}
                    >{ title }</FormLabel> : null }
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    <div className={ `${styles.formGroup} ${classes.formGroup || ''}` }>
                        { renderChips }
                    </div>
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

CompetencySelectField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
        groupLabelPlacement: PropTypes.oneOf(['top', 'left']),
        groups: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string
        })),
        canAddCustomCompetencies: PropTypes.bool
    }),
    valueOptions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        id: PropTypes.number,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        icon: PropTypes.string,
        group: PropTypes.string,
        definitionText: PropTypes.string,
        disabled: PropTypes.bool,
        competencyName: PropTypes.string,
        competencyDefinition: PropTypes.string,
        isGlobalCompetency: PropTypes.bool
    })),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            formGroup: PropTypes.string,
            groupLabelContainer: PropTypes.string,
            groupChipContainer: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string,
            input: PropTypes.string,
            chipContainer: PropTypes.string,
            labelContainer: PropTypes.string,
            chipLabelSelected: PropTypes.string,
            chipLabelDisabled: PropTypes.string,
            label: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    showModalToAddCompetencyAlias: PropTypes.func,
    showModalToAddCustomCompetency: PropTypes.func,
    i18n: PropTypes.object
};

CompetencySelectField.defaultProps = {
    title: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {
        groupLabelPlacement: 'top',
        groups: []
    },
    valueOptions: [],
    uiSchema: {},
    inputValue: [],
    helperText: '',
    i18n: {}
};
